import { useTranslation } from 'react-i18next'
import { AppIcon } from '../icons/AppIcon'
import { useFeedback } from './FeedbackContext'
import { FeedbackKindMenu } from './FeedbackKindMenu'

export function AuthFeedbackButton() {
  const { t } = useTranslation(['dashboard', 'common'])
  const { ready } = useFeedback()

  return (
    <FeedbackKindMenu
      placement="top-start"
      anchorClassName="fixed bottom-6 left-6 z-40"
      trigger={
        <button
          type="button"
          disabled={!ready}
          aria-label={t('dashboard:sidebar.feedback.ariaLabel')}
          className={[
            'flex items-center gap-2.5',
            'rounded-full sm:rounded-xl',
            'bg-[#2a2a2a] hover:bg-[#333333] border border-[#404040]',
            'px-4 py-3 text-sm font-medium text-white shadow-lg',
            'transition-colors',
            'focus:outline-none focus:ring-2 focus:ring-[#FF5A00] focus:ring-offset-2 focus:ring-offset-[#0d0d0d]',
            'disabled:opacity-50 disabled:pointer-events-none',
          ].join(' ')}
        >
          <span className="flex-shrink-0 w-7 h-7 rounded-md bg-[#0f0f0f] flex items-center justify-center">
            <AppIcon name="bug-beetle" size={16} className="text-white" />
          </span>
          <span className="hidden sm:inline font-switzer">
            {t('dashboard:sidebar.feedback.label')}
          </span>
        </button>
      }
    />
  )
}
